import React from "react";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import { Waypoint } from "react-waypoint";
import SearchBar from "../../components/SearchBar";
import Select from "react-select";
import qs from "query-string";

const GET_USERS = gql`
  query GET_USERS($limit: Int, $after: String, $search: String, $role: String) {
    users(limit: $limit, after: $after, search: $search, role: $role) {
      id
      name
      email
      phone
      lastTimeLoggedIn
    }
    roles: userRoles {
      name
      group
      displayName
    }
    viewer {
      id
      isUserAuthenticated
      roles
    }
  }
`;

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      role: "",
      selected: {
        value: "",
        label: "All Roles",
      },
    };
    this.typingTimer;
    this.doneTypingInterval = 300;
  }

  tryParseJson(value, defaultValue) {
    try {
      return value ? JSON.parse(value) : value;
    } catch {
      return defaultValue;
    }
  }

  componentWillMount() {
    const { search, role, selected } = qs.parse(this.props.location.search);
    const serializedSelectedValue = this.tryParseJson(selected, {
      value: "",
      label: "All Roles",
    });

    this.setState({
      search: search ?? this.state.search,
      role: role ?? this.state.role,
      selected: serializedSelectedValue,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const oldQueryString = qs.stringify({
      search: prevState.search,
      role: prevState.role,
      selected: JSON.stringify(prevState.selected),
    });
    const newQueryString = qs.stringify({
      search: this.state.search,
      role: this.state.role,
      selected: JSON.stringify(this.state.selected),
    });
    if (oldQueryString !== newQueryString) {
      this.props.history.push({
        search: `?${newQueryString}`,
      });
    }
  }

  onClickUser = (user) => {
    this.props.history.push(`/edit-user/${user.id}`);
  };

  renderTableRows = (users, columns) => {
    if (!users.length) {
      return;
    }
    return users.map((user, i) => (
      <tr
        key={i}
        data-cy={`user-row-${i}`}
        className="user-link-row"
        onClick={() => this.onClickUser(user)}
      >
        {columns.map(({ field }, j) => (
          <td key={j} data-cy={`user-column-${field}`}>
            {user[field] || "N/A"}
          </td>
        ))}
      </tr>
    ));
  };

  moreOnScroll = (data, fetchMore) => {
    return fetchMore({
      variables: {
        after: data.users && data.users[data.users.length - 1].id,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return Object.assign({}, prev, {
          users: [...(prev.users || []), ...(fetchMoreResult.users || [])],
        });
      },
    });
  };

  loadMoreOnScroll = (data, fetchMore) => {
    if (data.users.length > 1) {
      this.moreOnScroll(data, fetchMore).catch(console.log);
    }
  };

  onFilterChange = (selectedOption) => {
    this.setState({
      role: selectedOption.value,
      selected: selectedOption,
    });
  };

  onFinishedTyping = (searchText) => {
    this.setState({ search: searchText });
  };

  onSearch = (e) => {
    e.persist();
    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(
      () => this.onFinishedTyping(e.target.value),
      this.doneTypingInterval
    );
  };

  render() {
    return (
      <div>
        <div className="page-header">
          <i className="fas fa-address-book fa-lg"></i>
          <h3>Users</h3>
        </div>

        <SearchBar
          data-cy="user-search"
          placeholder="Search"
          classes={["border", "rounded"]}
          onKeyUp={this.onSearch}
          inputValue={this.state.search}
        />
        <Query
          query={GET_USERS}
          variables={{
            search: this.state.search,
            role: this.state.role,
          }}
        >
          {({ loading, error, data, fetchMore }) => {
            if (loading) return "Loading...";
            if (error) return `Error! ${error.message}`;

            let roleList = [
              {
                value: "",
                label: "All Roles",
              },
            ];
            data.roles.forEach((elem) => {
              roleList.push({
                value: elem.name,
                label: elem.group + ": " + elem.displayName,
              });
            });

            let tableColumns = [
              {
                display: "ID",
                field: "id",
              },
              {
                display: "Last Login",
                field: "lastTimeLoggedIn",
              },
              {
                display: "Email",
                field: "email",
              },
              {
                display: "Name",
                field: "name",
              },
            ];

            if (
              data.viewer &&
              data.viewer.roles.some(
                (role) => role.toLowerCase() === "phone_number_access"
              )
            ) {
              tableColumns.push({
                display: "Phone",
                field: "phone",
              });
            }

            return (
              <div>
                <Select
                  value={this.state.selected}
                  onChange={this.onFilterChange}
                  options={roleList}
                  data-cy={"user-role-select"}
                />
                <div
                  style={{
                    overflowX: "auto",
                    overflowY: "auto",
                    height: "68vh",
                  }}
                >
                  <table className="table table-bordered">
                    <tbody>
                      <tr>
                        {tableColumns.map(({ display }, i) => (
                          <th key={i}>{display}</th>
                        ))}
                      </tr>
                      {this.renderTableRows(data.users, tableColumns)}
                    </tbody>
                  </table>
                  {!loading && (
                    <Waypoint
                      onEnter={() => this.loadMoreOnScroll(data, fetchMore)}
                    />
                  )}
                  {!data.users.length > 0 ? (
                    <b>There are no users that meet that criteria.</b>
                  ) : (
                    false
                  )}
                </div>
              </div>
            );
          }}
        </Query>
      </div>
    );
  }
}

export default Home;
